export default "__VITE_ASSET__DX_NH7lq__"